

import config from 'components/config/config';

config();